















































































































































import { AuthLayoutVueFS } from "@/extensions/layouts/AuthLayoutVueFS";
import { Component } from "vue-property-decorator";
import CommonFooter from "@/components/navigation/CommonFooter.vue";
import AuthNavigation from "@/components/navigation/AuthNavigation.vue";
import { getCookie } from "fs-pb-vue2/utilities/cookieHelper";
import AppError from "@/components/app/AppError.vue";

@Component({
  components: { CommonFooter, AuthNavigation, AppError }
})
export default class AuthLayout extends AuthLayoutVueFS {

  async created() {
    await this.init();
  }

  mounted(): void {
    if (this.isPwa)
      this.isPwaClosed = true;
    else
      this.isPwaClosed = window.localStorage.getItem('pwaInfoClosed') === '1';
  }

  isPwaClosed: boolean = false;

  pwaInfoDialog: boolean = false;

  closePwaInfo(): void {
    this.isPwaClosed = true;
    window.localStorage.setItem('pwaInfoClosed', '1');
  }

  get isPwa(): boolean {
    return ["fullscreen", "standalone", "minimal-ui"].some(
        (displayMode) => window.matchMedia('(display-mode: ' + displayMode + ')').matches
    );
  }

  /**
  * Признак мобильного браузера
  */
  get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  get isIOSPlatform(): boolean {
    const userAgent = navigator.userAgent;
    const iosRegExp = /iPhone|iPad|iPod/i;
    return iosRegExp.test(userAgent);
  }

}
